/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hasbutstatus3Inputs */

const de__field_hasbutstatus3 = /** @type {(inputs: _Field_Hasbutstatus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT-Status`)
};

/**

* @param {_Field_Hasbutstatus3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hasbutstatus3 = /** @type {((inputs?: _Field_Hasbutstatus3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hasbutstatus3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_hasbutstatus3(inputs)
});
export { _field_hasbutstatus3 as "_field_hasBuTStatus" }